// New-order / new-ride chime. Uses the shared brand ring asset (call_ring.wav) so every
// surface rings with the same sound. Falls back silently if audio is blocked.
let ctx = null;
const CHIME_URL = "/call_ring.wav";
let chimeAudio = null;

function getChimeAudio() {
  if (typeof Audio === "undefined") return null;
  if (!chimeAudio) {
    chimeAudio = new Audio(CHIME_URL);
    chimeAudio.preload = "auto";
  }
  return chimeAudio;
}

export function unlockAudio() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    // Prime the brand chime element so it can play on its own afterwards.
    const a = getChimeAudio();
    if (a && a.paused && !a._primed) {
      a._primed = true;
      a.play().then(() => { a.pause(); a.currentTime = 0; }).catch(() => {});
    }
    return true;
  } catch {
    return false;
  }
}

// Browsers keep the AudioContext "suspended" until the user interacts with the page, so a
// new-order chime can be silent until the restaurant clicks something. Arm a one-time
// listener that unlocks audio on the very first interaction with the board, so the chime
// reliably rings on its own afterwards. Safe to call repeatedly (guards against double-arm).
let armed = false;
export function armAudioUnlock() {
  if (armed || typeof window === "undefined") return;
  armed = true;
  const handler = () => {
    unlockAudio();
    window.removeEventListener("pointerdown", handler);
    window.removeEventListener("keydown", handler);
    window.removeEventListener("touchstart", handler);
  };
  window.addEventListener("pointerdown", handler, { once: false });
  window.addEventListener("keydown", handler, { once: false });
  window.addEventListener("touchstart", handler, { once: false });
}

let ringTimer = null;
// Repeats the chime until stopRinging() — used by the new-order / new-ride ring modals.
export function startRinging() {
  if (ringTimer) return;
  playChime();
  ringTimer = setInterval(playChime, 2500);
}
export function stopRinging() {
  if (ringTimer) { clearInterval(ringTimer); ringTimer = null; }
}

export function playChime() {
  try {
    unlockAudio();
    const a = getChimeAudio();
    if (!a) return;
    a.currentTime = 0;
    a.play().catch(() => {});
  } catch {
    /* ignore audio errors */
  }
}


// A soft two-note "ding-dong" — played when a delivery partner reaches the counter.
// Deliberately distinct from the bright ascending new-order chime above.
export function playArrival() {
  try {
    if (!unlockAudio()) return;
    const now = ctx.currentTime;
    const notes = [523.25, 392.0]; // C5 -> G4
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const t = now + i * 0.22;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.3, t + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.7);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.75);
    });
  } catch {
    /* ignore audio errors */
  }
}
